import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import FinancialReportStepsOneAutomaticIncomeForm from './FinancialReportStepsOneAutomaticIncomeForm';


const FinancialReportAutomaticIncomes = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const prevNavigationQuery = location.state?.prevQuery ? [...location.state.prevQuery] : [];

  return (
    <Container>
      <Row>
        <Col sm={12} className="d-flex justify-content-end">
          <button onClick={() => {
            navigate(`/financials/reports/${id}/incomes/income`, {
              state: { prevQuery: prevNavigationQuery, }
            })
          }} className="btn btn-success">Manual Income</button>
        </Col>
        <Col className="col-12" md={8} lg={6}>
          <h1>Step 1</h1>
          <FinancialReportStepsOneAutomaticIncomeForm />
        </Col>
      </Row>
    </Container>
  );
};

export default FinancialReportAutomaticIncomes;
